import "./bootstrap";

import OCL from "openchemlib/full";
window.OCL = OCL;
